import $ from 'jquery';

let collapse = {
  triggersSelector: '[data-collapse-trigger][data-collapse-trigger!="initialized"]',
  $triggers: undefined,

  /**
   * @returns {void}
   */
  initialize: function () {

    collapse.$triggers = $(collapse.triggersSelector);
    if (collapse.$triggers.length === 0) {
      return;
    }

    collapse.$triggers.on('click', function (event) {
      let $trigger = $(this);
      let $item = $trigger.closest('[data-collapse-item]');
      let $target = $item.find('[data-collapse-target]').first();
      let targetHeight = $target.find('> *').outerHeight(true);

      event.preventDefault();

      $target.off('.collapse');

      if ($item.attr('data-collapse-item') === 'expanded') {
        $trigger.attr('aria-expanded', 'false');
        $item.attr('data-collapse-item', '');
        $target.css({
          'max-height': targetHeight
        });
        $target.attr('inert', '');
        setTimeout(
          () => {
            $target.removeAttr('style');
          },
          10
        );
      } else {
        if (targetHeight > 0) {
          $target.on(
            'transitionend.collapse transitioncancel.collapse',
            function () {
              $target.css({
                'max-height': 'none'
              });
              $target.off('.collapse');
            }
          );

          $target.css({
            'max-height': targetHeight
          });
        }
        $trigger.attr('aria-expanded', 'true');
        $item.attr('data-collapse-item', 'expanded');
        $target.removeAttr('inert');
      }
    });
    collapse.$triggers.each(function () {
      let $item = $(this).closest('[data-collapse-item]');

      if ($item.attr('data-collapse-item') === 'expanded') {
        $item.find('[data-collapse-target]').first().css({
          'max-height': 'none'
        });
      }
    });
    collapse.$triggers.attr('data-collapse-trigger', 'initialized');
  }
};

$(window).on('refresh', function () {
  collapse.initialize();
});
collapse.initialize();
